import React from 'react'
import styles from './Answer.module.scss'
import Icon from '../Icons'

const Answer = (props) => {

    const { answer, answerIndex, locked, callback } = props

    return (
        <div className={styles.holder}>
            <div className={` ${styles.answer} ${answer.selected ? styles.selected : ''} `} 
                onClick={() => { locked ? callback({...answer, selected: !answer.selected} , answerIndex) : void(0) }  } >
                {answer.option}
                
            </div>
            {locked && <div className={styles.icon}>
                { answer.correct && !locked && <Icon name='check' /> }
                { !answer.correct && !locked && <Icon name='incorrect' /> }
            </div>}
        </div>
    )
}
export default Answer